<script setup lang="ts">
interface Props {
  name: string;
  iconUrl?: string | null;
  earned: boolean;
  earnedCount?: number;
  size?: 'sm' | 'md' | 'lg';
  interactive?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  iconUrl: null,
  earnedCount: 0,
  size: 'sm',
  interactive: false,
});

const sizeStyles = computed(() => {
  return {
    'size-24': props.size === 'sm',
    'size-32': props.size === 'md',
    'size-36 md:size-40': props.size === 'lg',
  };
});
</script>

<template>
  <component
    :is="interactive ? 'button' : 'div'"
    :type="interactive ? 'button' : undefined"
    class="flex flex-col items-center"
    :class="interactive ? 'cursor-pointer transition-transform hover:scale-105' : 'pointer-events-none'"
  >
    <div class="relative">
      <NuxtImg
        v-if="iconUrl"
        :src="iconUrl"
        :alt="name"
        class="rounded-full object-cover"
        :class="[sizeStyles, { 'grayscale opacity-50': !earned }]"
      />
      <div
        v-else
        :class="sizeStyles"
        class="rounded-full bg-primary-foreground/20"
      />
      <div
        v-if="earnedCount > 1"
        class="absolute -right-0.5 -top-0.5 flex size-7 items-center justify-center rounded-full bg-white text-xs font-semibold text-foreground shadow-md"
      >
        {{ earnedCount }}
      </div>
    </div>
  </component>
</template>
